import { ApiRequestInterceptor } from "./apiRequest";
import { PRODUCTOS } from "../constants/endpoints/endpoints";

export const fetchProductos = async () => {
    const method = "GET";
    const response = await ApiRequestInterceptor(PRODUCTOS.productos, method);
    const { code, data } = response;

    if (code === 200) {
        return { code, data };
    } else {
        throw new Error("Error al obtener datos de productos");
    }
};
